import { createReducer, on } from '@ngrx/store';
import {
  CategoryWifiProfileApiActions,
  CategoryWifiProfileViewActions,
} from './category-wifi-profile-configuration.actions';
import { adapter, initialState, selectId } from './category-wifi-profile-configuration.state';

export const categoryWifiProfileReducer = createReducer(
  initialState,
  on(CategoryWifiProfileApiActions.categoryWifiProfilesLoaded, (state, { wifiProfiles }) => {
    return adapter.setMany(wifiProfiles, state);
  }),
  on(
    CategoryWifiProfileViewActions.wifiProfileConfigurationsUpdated,
    (state, { category, updatedWifiProfilesLinkedToCategory }) => {
      // Clear store for given category and add new profiles
      const intermediateState = adapter.removeMany((x) => selectId(x).includes(category.categoryId), state);
      return adapter.setMany(updatedWifiProfilesLinkedToCategory, intermediateState);
    }
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectCategoryWifiProfileIds = selectIds;

export const selectCategoryWifiProfileEntities = selectEntities;

export const selectAllCategoryWifiProfiles = selectAll;
